import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchUsersTable() {
  yield takeLatest('userOfficeGroups/fetchTable', fetchTable);
}

function* watchFetchUserDetail() {
  yield takeLatest('userOfficeGroups/fetchDetail', fetchDetail);
}

function* watchSubmitUserDetail() {
  yield takeLatest('userOfficeGroups/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([fork(watchFetchUsersTable), fork(watchFetchUserDetail), fork(watchSubmitUserDetail)]);
}
